import { IBarcode } from "interfaces/IBarcode"
import { useBarcode } from "react-barcodes"
import JsBarcode from "jsbarcode"
import { useEffect, useRef } from "react"

const BarCodeSVG = (props: IBarcode) => {
  const { value, height = 100, fontSize = 16, displayValue = true }: any = props
  const svgRef = useRef<SVGSVGElement>(null)
  
  useEffect(() => {
    if (!svgRef.current || !value) return
    
    try {
      JsBarcode(svgRef.current, value, {
        format: "CODE128",
        font: "system-ui",
        width: 3,
        height,
        fontSize,
        displayValue,
      })
    } catch (error) {
      console.error("Error generating barcode:", error)
    }
    // eslint-disable-next-line
  }, [props])

  if (!value) {
    return null
  }

  return (
    <svg
      ref={svgRef}
      style={{
        width: "500px",
        height: "150px",
      }}
    />
  )
}

const BarCodeCanvas = ({ value, fontSize = 16, height = 70, displayValue = true }: IBarcode) => {
  const { inputRef } = useBarcode({
    value,
    options: {
      font: "system-ui",
      format: "CODE128",
      fontSize,
      height,
      displayValue,
    },
  })

  return <canvas style={{ width: "100%" }} ref={inputRef} />
}

const Barcode = ({ showSvg = false, value, fontSize = 16, height = 70, displayValue = true }: IBarcode) => {
  if (showSvg) {
    return <BarCodeSVG value={value} height={height} fontSize={fontSize} displayValue={displayValue} />
  }

  return <BarCodeCanvas value={value} fontSize={fontSize} height={height} displayValue={displayValue} />
}

export default Barcode
